/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Manageroles_Editdescription2Inputs */

const en_settings_collaborators_manageroles_editdescription2 = /** @type {(inputs: Settings_Collaborators_Manageroles_Editdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change roles per vehicle type.`)
};

/**
* | output |
* | --- |
* | "Change roles per vehicle type." |
*
* @param {Settings_Collaborators_Manageroles_Editdescription2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_manageroles_editdescription2 = /** @type {((inputs?: Settings_Collaborators_Manageroles_Editdescription2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Manageroles_Editdescription2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_manageroles_editdescription2(inputs)
});
export { settings_collaborators_manageroles_editdescription2 as "settings_collaborators_manageRoles_editDescription" }